import { DckActionCreators, DckSelectors } from "dck-redux"
import React from "react"
import { connect } from "react-redux"
import {
  fillingZeroUtility,
  getAccessToken,
  INVALID_TOKEN,
  LoanGroupEnum,
  parseFetchError
} from "../../lib/utils"
import processTypes from "../../redux/processes/types"
import apiServerApi from "../../redux/sagas/apiServerApi"
import AlertModal from "../fragments/AlertModal"
import reduxStore from '../../store'
import * as ItemTypes from "../../redux/items/types"
import ProcessesStatus from "../fragments/ProcessesStatus"

class UpdateLoanGroupForm extends React.Component {

  state = {
    group: '',
    show: false,
    running: false,
    success: false,
    error: null,
  }

  updateLoanGroupClicked = async () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { setLoan, callback, selectedLoans } = this.props,
    { group } = this.state,
    validLoans = selectedLoans.filter(loan => loan.group !== group),
    accessToken = getAccessToken()

    try {

      for (const loan of validLoans) {
        const resp = await apiServerApi.updateLoanGroup(accessToken, loan.id, group)
        setLoan(loan.id, resp.body)
      }

      this.setState({ success: true })

      setTimeout(() => {
        this.handleClose()
        if (callback) {
          callback()
        }
      }, 800)
    }
    catch (error) {

      console.error(error)
      const content = parseFetchError(error)

      if (content.text === INVALID_TOKEN) {
        reduxStore.dispatch(DckActionCreators.signOut())
      }
      this.setState({ error: content.text })
    }
    finally {
      this.setState({ running: false })
    }
  }

  groupChanged = group => this.setState({
    group,
    show: true
  })

  getFirstGroupName = loans => loans && loans.length ? loans[0].group : ''

  handleClose = () => this.setState({
    running: false,
    success: false,
    error: null,
    show: false,
  })

  renderContent = () => {

    const { nbItems } = this.props,
    { group, running, error, success } = this.state,
    pronoun = nbItems > 1 ? `these ${ fillingZeroUtility(nbItems) } loans` : 'this loan'

    return (
      <div>
        <h3>{ group === LoanGroupEnum.DEFAULTED
          ? `Are you sure you want to mark ${ pronoun } as defaulted?`
          : `Are you sure you want to remove ${ pronoun } from Defaults?`
        }</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  render() {

    const { selectedLoans } = this.props,
    { show, group, running } = this.state,

    isDefaulted = group === LoanGroupEnum.DEFAULTED,
    groupName = this.getFirstGroupName(selectedLoans),

    title = <span>{ isDefaulted ? 'Confirm update' : 'Confirm removal' }</span>,
    bsStyle= isDefaulted ? 'primary' : 'danger',

    proceedText= isDefaulted ? 'Update' : 'Remove'

    return (
      <span>
        <select
          className="assignToSelect"
          value={ groupName ? groupName : '' }
          onChange={e => this.groupChanged(e.target.value)}>
          { Object.keys(LoanGroupEnum).map(grp =>
            <option key={ grp } value={ grp }>{ grp }</option>
          )}
        </select>

        <AlertModal
          show={ show }
          close={ this.handleClose }
          confirm={ this.updateLoanGroupClicked }
          title={ title }
          body={ this.renderContent() }
          bsStyle={ bsStyle }
          proceedText={ proceedText }
          disabled={ running }
        />
      </span>
    )
  }
}

const mapStateToProps = state => {

  const processRunning = DckSelectors.selectProcessRunning(
    state,
    processTypes.UPDATE_LOAN_GROUP_PROCESS
  ),

  processFailed = DckSelectors.selectProcessFailed(
    state,
    processTypes.UPDATE_LOAN_GROUP_PROCESS
  )

  return { processRunning, processFailed }
},

mapDispatchToProps = dispatch => ({
  setLoan: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Loan, id, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateLoanGroupForm)



// WEBPACK FOOTER //
// ./src/components/Loans/UpdateLoanGroupForm.js